import MaterialTable from "@material-table/core";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";

import { Globals } from "../../helpers/globals";
import Footer from "../../components/shared/Footer";
import pdfIcon from "../../assets/images/file-icons/pdf.svg";
import zipIcon from "../../assets/images/file-icons/zip.svg";

import CreateMatterManagmentPage from "./CreateMatterManagmentPage";
import * as Cols from "./MatterManagmentColumns";
import { MatterService } from "../../services/ClientService";
import * as APIModels from "../../models";
import { KeyValueStore } from "./BetaTypes";
import { FileService, ReportService } from "../../services/SubmissionService";
import { Endpoints } from "../../helpers/Endpoints";
import { useDropzone } from "react-dropzone";
import { formatBytes } from "../../helpers/utility";
import { MatterManagmentService } from "../../models/swagger/generated-client-service";

const never = "never" as const;
const bool = "boolean" as const;

type MatterNumberObj = {
    id: string;
    matterNumber: string;
    courtCaseNumber: string;
    county: string;
    countyId: string;
    caseTitle: string;
    caseStatus: string;
    statusId: string;
    active: boolean;
};

export { CreateMatterManagmentPage };

export default function MatterManagmentPage() {
    const [organizationId, setorganizationId] = useState(
        Globals.currentUserValue.organizationID
    );
    const f: APIModels.FileInfo[] = [];
    const [files, setFiles] = useState(f);

    /* these ore for the new component eventually */
    const [templates, setTemplates] = useState(f);
    const [merged, setMerged] = useState(f);
    /* -------------------------------------------*/

    const [selectedFiles, setSelectedFiles] = useState(f);
    const iframeRef = useRef<HTMLEmbedElement>(null);
    const [refresh, setRefresh] = useState(false);
    const [matters, setMatters] = useState([] as Array<MatterNumberObj>);
    const [hoverElement, setHoverElement] = useState(
        null as HTMLElement | null
    );

    const [eFileUpload, seteFileUpload] = useState(
        null as APIModels.eFile | null
    );

    const [isCheckAll, setIsCheckAll] = useState(false);

    const currentUser = Globals.currentUserValue;

    useEffect(() => {
        FileService.list({
            route: "templates",
        }).then(
            (resp) => {
                if (resp.successful === true && resp.data) {
                    setTemplates(resp.data);
                }
            },
            (error) => {
                console.error(error);
            }
        );
        FileService.list({
            route: "merged",
        }).then(
            (resp) => {
                if (resp.successful === true && resp.data) {
                    const r = resp.data.filter((d) => {
                        if (d.filename !== "") return d;
                    });
                    console.log(r);

                    setMerged(r);
                }
            },
            (error) => {
                console.error(error);
            }
        );
        setRefresh(false);
    }, [refresh]);

    const handleMouseOver = (
        event: React.MouseEvent<HTMLImageElement>,
        file: APIModels.FileInfo
    ) => {
        if (file.filename!.indexOf(".pdf") > 0) {
            setHoverElement(event.currentTarget);

            FileService.get({
                submissionId: currentUser.id + "/uploads",
                documentId: file.filename ?? "",
                source: "upload",
            }).then(
                (resp) => {
                    resp.json().then((json) => {
                        if (iframeRef && iframeRef.current)
                            iframeRef.current.src = json.url;
                    });
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    const onDownload = (filename: string) => {
        FileService.get({
            submissionId: currentUser.id + "/merged",
            documentId: filename,
            source: "upload",
        }).then(
            (resp) => {
                resp.json().then((json) => {
                    const url = json.url;
                    console.log(url);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            },
            (error) => console.log(error)
        );
    };

    const handleMouseOut = (event: React.MouseEvent<HTMLImageElement>) => {
        if (event.currentTarget == hoverElement) {
            setHoverElement(null);
        }
    };

    const onDrop = useCallback(
        (acceptedFiles) => {
            const filInfo = [...files];

            acceptedFiles.forEach((file: any) => {
                filInfo.push({ filename: file.name, size: file.size });

                FileService.upload({
                    fileServiceUrl: Endpoints.FileManager,
                    file: file,
                    filename: "/templates/" + file.name,
                }).then(
                    (resp) => {
                        setRefresh(!refresh);
                        resp.text().then((text) => console.log(text));
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            });

            setFiles(filInfo);
        },
        [files]
    );

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true,
        maxSize: 35000000,
        accept: "application/pdf",
        multiple: true,
    });

    const onFileUpload = (event: React.FormEvent) => {
        event.preventDefault();
        const input = event.target as HTMLInputElement;

        if (!input.files?.length) {
            return;
        }
        const filInfo = [...files];

        for (let i = 0; i < input.files.length; i++) {
            const f = input.files[i];

            filInfo.push({ filename: f.name, size: f.size });
            setFiles(filInfo);

            FileService.upload({
                fileServiceUrl: Endpoints.FileManager,
                file: f,
                filename: "templates/" + f.name,
            }).then(
                (resp) => {
                    setRefresh(!refresh);
                    input.value = "";
                },
                (error) => {
                    input.value = "";
                }
            );
        }
    };

    const onFileMerge = (matterID: string, file: APIModels.FileInfo) => {
        MatterManagmentService.merge({
            body: {
                matterID: matterID,
                path: `${currentUser.id}/templates`,
                filename: file.filename ?? "",
            },
        })
            .then((res) => {
                if (res.data && res.successful) {
                    alert("");
                } else {
                    console.error(res.errorMessage);
                }
            })
            .finally(() => setRefresh(true));
    };

    const onFileDownload = (event: React.FormEvent) => {
        event.preventDefault();
        const input = event.target as HTMLInputElement;

        console.log(input);
    };

    const onDelete = (file: APIModels.FileInfo) => {
        if (file.filename) {
            FileService.delete({ filename: file.filename }).then(
                (resp) => {
                    setRefresh(!refresh);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    const hoverPreview = () => {
        const rect = hoverElement!.getBoundingClientRect();
        return (
            <div
                style={{
                    position: "fixed",
                    top: rect.top,
                    left: rect.left,
                    height: "800px",
                    width: "800px",
                    backgroundColor: "white",
                    pointerEvents: "none",
                }}
            >
                <embed
                    ref={iframeRef}
                    type="application/pdf"
                    style={{ height: "800px", width: "800px" }}
                ></embed>
            </div>
        );
    };

    const handleSelectAll = () => {
        setIsCheckAll(!isCheckAll);

        if (isCheckAll) {
            setSelectedFiles([]);
        } else {
            setSelectedFiles(files);
        }
    };

    const onSelectFile = (index: number, file: APIModels.FileInfo) => {
        const matchingIndex = selectedFiles.findIndex(
            (v) => v.filename === file.filename
        );

        if (matchingIndex >= 0) {
            const filesUpdated = [...selectedFiles];
            filesUpdated.splice(matchingIndex, 1);
            setSelectedFiles(filesUpdated);
        } else {
            setSelectedFiles([...selectedFiles, file]);
        }

        return false;
    };

    useEffect(() => {
        MatterService.getAll({
            organizationId: organizationId ?? APIModels.EmptyGuid,
        }).then((res) => {
            if (res.data && res.successful) {
                const objs = res.data.map<MatterNumberObj>((matter) => {
                    const dynamoDbObject =
                        matter.dynamoDbEntry as KeyValueStore;
                    return {
                        id: matter.id,
                        matterNumber: matter.matterNumber,
                        courtCaseNumber: dynamoDbObject.caseNumber ?? "",
                        county: dynamoDbObject.county ?? "Alucha",
                        caseTitle:
                            (dynamoDbObject.plaintiff ?? "UNKNOWN") +
                            " v. " +
                            (dynamoDbObject.def1 ?? "UNKNOWN"),
                        caseStatus: "Submitting",
                        statusId: "c160bd9d-fc1c-421a-85f1-1a0ec1047cb8",
                        active: true,
                    } as MatterNumberObj;
                });

                setMatters(objs);
            } else {
                console.error(res.errorMessage);
            }
        });
    }, [organizationId]);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Matter Managment</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="/dashboard"> eFileMadeEasy </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Matter Managment
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="row col-md-6 mb-3">
                                <div className="col-6">
                                    <a
                                        href="/create-new-matter"
                                        type="button"
                                        className="btn btn-primary float-right mr-3"
                                    >
                                        Create New Matter +
                                    </a>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div
                                        style={{ maxWidth: "100%", zIndex: 20 }}
                                    >
                                        <></>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-12">
                                <div
                                    {...getRootProps({
                                        className: "dropzone",
                                    })}
                                    style={{ border: "none" }}
                                >
                                    <input {...getInputProps()} />
                                    <div className="text-center">
                                        <i className="h1 text-muted ri-upload-cloud-2-line">
                                            ...
                                        </i>
                                        <h3 className="text-center">
                                            Drop files here or click button to
                                            upload.
                                        </h3>
                                    </div>

                                    <div className="fileupload btn btn-success waves-effect waves-light mb-3">
                                        <span>
                                            <i className="mdi mdi-cloud-upload me-1"></i>{" "}
                                            Upload Files
                                        </span>
                                        <input
                                            type="file"
                                            className="upload"
                                            onChange={onFileUpload}
                                            multiple
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {" "}
                            <div
                                className="table-responsive"
                                style={{ overflow: "visible" }}
                            >
                                {hoverElement && hoverPreview()}
                                <table
                                    className="table table-centered  table-nowrap mb-0"
                                    style={{ zIndex: 0 }}
                                >
                                    <thead className="table-light">
                                        <tr>
                                            <th scope="col">
                                                <input
                                                    className="me-2"
                                                    type="checkbox"
                                                    checked={isCheckAll}
                                                    onChange={handleSelectAll}
                                                />
                                                Select All
                                            </th>

                                            <th scope="col">File Name</th>
                                            <th scope="col">Date Modified</th>
                                            <th scope="col">Size</th>
                                            <th
                                                scope="col"
                                                className="text-center"
                                                style={{ width: 125 }}
                                            >
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {templates.map((file, i) => {
                                            if (file.filename !== "")
                                                return (
                                                    <tr>
                                                        <td>
                                                            <input
                                                                key={i}
                                                                type="checkbox"
                                                                checked={
                                                                    selectedFiles.filter(
                                                                        (v) =>
                                                                            v.filename ===
                                                                            file.filename
                                                                    ).length > 0
                                                                }
                                                                onChange={() =>
                                                                    onSelectFile(
                                                                        i,
                                                                        file
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <img
                                                                src={
                                                                    file.filename &&
                                                                    file.filename
                                                                        .toLowerCase()
                                                                        .endsWith(
                                                                            ".pdf"
                                                                        )
                                                                        ? pdfIcon
                                                                        : zipIcon
                                                                }
                                                                height="30"
                                                                alt="icon"
                                                                className="me-2"
                                                                onMouseEnter={(
                                                                    e
                                                                ) =>
                                                                    handleMouseOver(
                                                                        e,
                                                                        file
                                                                    )
                                                                }
                                                                onMouseLeave={
                                                                    handleMouseOut
                                                                }
                                                            />
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="text-dark"
                                                            >
                                                                {file.filename}
                                                            </a>
                                                        </td>
                                                        <td className="font-13">
                                                            {
                                                                file.lastUpdatedDateTime
                                                            }
                                                        </td>
                                                        <td>
                                                            {formatBytes(
                                                                file.size ?? 0
                                                            )}
                                                        </td>
                                                        {file.lastUpdatedDateTime ? (
                                                            <td>
                                                                {(selectedFiles.length ==
                                                                    0 ||
                                                                    selectedFiles.findIndex(
                                                                        (v) =>
                                                                            v.filename ===
                                                                            file.filename
                                                                    ) == 0) && (
                                                                    <div
                                                                        style={{
                                                                            display:
                                                                                "inline-block",
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="btn-group dropdown"
                                                                            style={{
                                                                                display:
                                                                                    "inline-block",
                                                                            }}
                                                                        >
                                                                            <a
                                                                                data-bs-toggle="dropdown"
                                                                                className="dropdown-toggle action-icon px-1"
                                                                            >
                                                                                <i className="mdi mdi-file-document me-2 text-muted font-18 vertical-middle"></i>
                                                                            </a>
                                                                            <div
                                                                                className="dropdown-menu dropdown-menu-end"
                                                                                style={{
                                                                                    zIndex: 1000,
                                                                                }}
                                                                            >
                                                                                {matters.map(
                                                                                    (
                                                                                        matter
                                                                                    ) => {
                                                                                        return (
                                                                                            <div
                                                                                                className="dropdown-item"
                                                                                                onClick={() =>
                                                                                                    onFileMerge(
                                                                                                        matter.id,
                                                                                                        file
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                {
                                                                                                    matter.matterNumber
                                                                                                }
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <a
                                                                            href="javascript:void(0);"
                                                                            className=""
                                                                            onClick={() =>
                                                                                onDelete(
                                                                                    file
                                                                                )
                                                                            }
                                                                        >
                                                                            {" "}
                                                                            <i className="mdi mdi-delete me-2 text-muted font-18 vertical-middle"></i>
                                                                        </a>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        ) : (
                                                            <td>
                                                                <div
                                                                    className="spinner-border text-primary m-2"
                                                                    role="status"
                                                                >
                                                                    <span className="visually-hidden">
                                                                        Loading...
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12">
                                <></>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
